import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initFirebaseAnalytics } from './auth/firebaseAnalytics';
import './styles/base.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

void initFirebaseAnalytics().catch((err: unknown) => {
  console.warn('Firebase Analytics init failed (non-fatal):', err);
});

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
